import { API } from '@/api';
import { type SearchableDropdownOption } from '@/components/SearchableDropdown';
import {
  DecoratedCompany,
  DecoratedInvestor,
} from '@flemingmetrics/api-client';
import { renderProfileName } from '@/utils/strings';

export type SelectOption = SearchableDropdownOption<number>;

export const classes = {
  dialogTitle: 'pb-2 items-center',
  dialog:
    'w-[98vw] min-w-[400px] max-w-[500px] min-h-[200px] max-h-[450px] h-[80vh] flex flex-col',
  body: 'flex flex-col w-full grow pt-8',
  dropdown: 'w-full mb-8',
  input: 'w-full mb-8',
};

export function buildCompanyOption(company: DecoratedCompany): SelectOption {
  return {
    label: company.name,
    value: company.id,
  };
}

export function buildInvestorOption(investor: DecoratedInvestor): SelectOption {
  return {
    label: renderProfileName(investor.profile),
    value: investor.id,
  };
}

export function addInvestorToCompany(companyId: number, investorId: number) {
  return API.Companies.addCompanyInvestor(companyId, investorId);
}
